module.exports = __webpack_public_path__ + "static/media/isophya_modestior_BD_004_APA.4161ca94.png";